import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

function PowerplantListing() {
  const [powerplants, setPowerplants] = useState([]);
  const [filteredPlants, setFilteredPlants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [plantQuery, setPlantQuery] = useState("");
  const [stateQuery, setStateQuery] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const plantsPerPage = 15;
 const slugify = (text = "") =>
    text
      .toLowerCase()
      .trim()
      .replace(/&/g, "and")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/(^-|-$)+/g, "");

  /* ================= FETCH DATA ================= */
  useEffect(() => {
    const fetchPlants = async () => {
      try {
        setLoading(true);

        const res = await axios.get(
          "https://backend-zkgn.onrender.com/api/cogen"
        );

        setPowerplants(res.data || []);
        setFilteredPlants(res.data || []);
      } catch (err) {
        console.error(err);
        setError("Failed to load cogeneration plants");
      } finally {
        setLoading(false);
      }
    };

    fetchPlants();
  }, []);

  /* ================= SEARCH & FILTER ================= */
  useEffect(() => {
    let results = powerplants;

    if (plantQuery.trim()) {
      results = results.filter((plant) =>
        plant.cogen_plant_name
          ?.toLowerCase()
          .includes(plantQuery.toLowerCase())
      );
    }

    if (stateQuery.trim()) {
      results = results.filter((plant) =>
        plant.state?.toLowerCase().includes(stateQuery.toLowerCase())
      );
    }

    setFilteredPlants(results);
    setCurrentPage(1);
  }, [plantQuery, stateQuery, powerplants]);

  /* ================= PAGINATION ================= */
  const totalPages = Math.ceil(filteredPlants.length / plantsPerPage);
  const indexOfLast = currentPage * plantsPerPage;
  const indexOfFirst = indexOfLast - plantsPerPage;
  const currentPlants = filteredPlants.slice(indexOfFirst, indexOfLast);

  const paginate = (page) => setCurrentPage(page);

  const getPageNumbers = () => {
    const pages = [];
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (currentPage <= 3) {
        pages.push(1, 2, 3, 4, "...", totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(
          1,
          "...",
          totalPages - 3,
          totalPages - 2,
          totalPages - 1,
          totalPages
        );
      } else {
        pages.push(
          1,
          "...",
          currentPage - 1,
          currentPage,
          currentPage + 1,
          "...",
          totalPages
        );
      }
    }
    return pages;
  };

  return (
    <div className="container-fluid py-4">
      {/* ================= SEARCH ================= */}
      <div className="search-panel mb-4">
        <div className="card shadow-sm border-0">
          <div className="card-body">
            <div className="row g-3 align-items-end">
              <div className="col-lg-6">
                <label className="form-label fw-semibold">
                  Search by Plant Name
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={plantQuery}
                  onChange={(e) => setPlantQuery(e.target.value)}
                  placeholder="Eg. Cogeneration Plant"
                  disabled={loading}
                />
              </div>

              <div className="col-lg-4">
                <label className="form-label fw-semibold">
                  Filter by State
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={stateQuery}
                  onChange={(e) => setStateQuery(e.target.value)}
                  placeholder="Eg. Maharashtra"
                  disabled={loading}
                />
              </div>

              <div className="col-lg-2 d-grid">
                <button
                  className="btn btn-outline-secondary"
                  disabled={loading}
                  onClick={() => {
                    setPlantQuery("");
                    setStateQuery("");
                  }}
                >
                  Clear
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ================= HEADING ================= */}
      <div className="mb-4">
        {loading ? (
          <h5 className="text-muted">Loading cogeneration plants…</h5>
        ) : error ? (
          <p className="text-danger">{error}</p>
        ) : (
          <h5 className="fw-bold text-tertiry">
            <strong>{filteredPlants.length}</strong> – Cogeneration Plants Found
          </h5>
        )}
      </div>

      {/* ================= LOADER ================= */}
      {loading && (
        <div className="d-flex flex-column align-items-center justify-content-center py-5">
          <div
            className="spinner-border text-primary"
            role="status"
            style={{ width: "3rem", height: "3rem" }}
          />
          <p className="mt-3 text-muted">
            Fetching cogeneration plant data…
          </p>
        </div>
      )}

      {/* ================= PLANT LIST ================= */}
      {!loading && (
        <div className="row">
          {currentPlants.length > 0 ? (
            currentPlants.map((plant) => (
              <div key={plant.cogen_id} className="col-lg-4 col-md-6 mb-4">
                <div className="card h-100 shadow-sm">
                  <div className="card-body">
                    <Link
                      className="plant-link"
                      to={`/cogenerationinfo/${slugify(
                        plant.cogen_plant_name
                      )}/${plant.cogen_id}`}
                    >
                      <h5 className="card-title fw-bold text-dark">
                        {plant.cogen_plant_name}
                      </h5>
                    </Link>

                    <p className="mb-1 plantdetails">
                      <strong style={{ color: "#D84D10" }}>Address:</strong>{" "}
                      {plant.city}
                    </p>

                    <p className="mb-0 plantdetails">
                      <strong style={{ color: "#D84D10" }}>Contact:</strong>{" "}
                      {plant.phone_number}, {plant.mobile_number}
                    </p>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p className="text-muted text-center">
              No cogeneration plants found.
            </p>
          )}
        </div>
      )}

      {/* ================= PAGINATION ================= */}
      {!loading && totalPages > 1 && (
        <nav className="d-flex justify-content-center mt-4">
          <ul className="pagination pagination-sm flex-wrap shadow-sm">
            {getPageNumbers().map((page, index) =>
              page === "..." ? (
                <li key={index} className="page-item disabled">
                  <span className="page-link">...</span>
                </li>
              ) : (
                <li
                  key={index}
                  className={`page-item ${
                    currentPage === page ? "active" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => paginate(page)}
                  >
                    {page}
                  </button>
                </li>
              )
            )}
          </ul>
        </nav>
      )}
    </div>
  );
}

export default PowerplantListing;
